import React, { useMemo } from "react";
import Skeleton from "../../../../components/skeleton";

/**
 * Skeleton loader for the items list in Drugs & Diseases.
 * @returns {JSX.Element} The skeleton component for items.
 */
const SkeletonItems: React.FC = () => {
  return useMemo(
    () => (
      <div className="space-y-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} className="h-14 w-full rounded-lg" />
        ))}
      </div>
    ),
    [],
  );
};

export default SkeletonItems;
